function SearchIcon({ color, className }) {
    return (
        <svg
            className={className}
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 18 18"
        >
            <path
                stroke={color}
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.5"
                d="M11.683 11.587l5 5M13.35 7.42a5.833 5.833 0 11-11.667 0 5.833 5.833 0 0111.667 0z"
            ></path>
        </svg>
    )
}

export default SearchIcon
